import { useContext, useMemo } from 'react';
import { Route, Routes } from 'react-router-dom';
import DashboardWrap from '../components/common/dashboardWrap';
import AccountStatement from '../pages/private/account-statement';
import AccountActivity from '../pages/private/accout-activity';
import Actions from '../pages/private/actions';
import ActiveRetirementEligibleDashboard from '../pages/private/are-dashboard';
import InactiveRetirementEligibleDashboard from '../pages/private/are-dashboard-inactive';
import ActiveRetirementEligibleUnpaidDashboard from '../pages/private/are-unpaid-dashboard';
import Beneficiaries from '../pages/private/beneficiaries';
import CaseList from '../pages/private/case-list';
import CobraBenefitsEnrollment from '../pages/private/cobra-benefits-enrollment';
import DashboardPage from '../pages/private/dashboard';
import DbInactiveDashboard from '../pages/private/db-inactive-dashboard';
import DbUnpaidLeaveDashboard from '../pages/private/db-unpaid-leave-dashboard';
import DcDashboard from '../pages/private/dc-dashboard';
import DcInactiveDashboard from '../pages/private/dc-inactive-dashboard';
import DcUnpaidLeaveDashboard from '../pages/private/dc-unpaid-leave-dashboard';
import DirectDeposit from '../pages/private/direct-deposit';
import DocumentSearch from '../pages/private/document-search';
import HealthAndInsurancePage from '../pages/private/health-and-insurance';
import HealthSavingsAndSpendingChannelPage from '../pages/private/health-savings-and-spending-channel';
import HsaInvestment from '../pages/private/hsa-investment';
import HwCobraDashboard from '../pages/private/hw-cobra-dashboard';
import HwDashboard from '../pages/private/hw-dashboard';
import HwDbDashboard from '../pages/private/hw-db-dashboard';
import HwDcDashboard from '../pages/private/hw-dc-dashboard';
import HwDbDcCobraDashboard from '../pages/private/hw-db-dc-cobra-dashboard';
import HwDbDcMidYearDashboard from '../pages/private/hw-db-dc-midyear-dashboard';
import HwDbDashboardInactive from '../pages/private/hw-db-inactive-dashboard';
import HwInactiveDashboard from '../pages/private/hw-inactive-dashboard';
import HwUnpaidLeaveDashboard from '../pages/private/hw-unpaid-leave-dashboard';
import LifeEvents from '../pages/private/life-events';
import NewHireDashboard from '../pages/private/new-hire-dashboard';
import Optimizer from '../pages/private/optimizer';
import OptimizerScore from '../pages/private/optimizer-score';
import ParticipantAccess from '../pages/private/participant-access'
import PayNow from '../pages/private/pay-now';
import PaymentInformation from '../pages/private/payment-information';
import PensionEstimate from '../pages/private/pension-estimate';
import PensionIndex from '../pages/private/pension-index';
import PensionProfile from '../pages/private/pensionProfile';
import ProfilePage from '../pages/private/profile';
import ResourcesPage from '../pages/private/resources';
import RetireOnline from '../pages/private/retire-online';
import RetirementPlanning from '../pages/private/retirement-planning';
import SavingsEnrollment from '../pages/private/savings-enrollment';
import SavingsSummary from '../pages/private/savings-summary';
import TaxWithholding from '../pages/private/tax-withholding';
import MissedBenefitPayments from '../pages/private/missedBenefitPayments';
import DocumentCenter from '../pages/private/documentCenter';
import TotalRewards from '../pages/private/total-rewards';
import TransactionHistory from '../pages/private/transaction-history';
import VerifyDependetPage from '../pages/private/verify-dependent';
import Footer from '../pages/widgets/Footer/Footer';
import Navigation from '../pages/widgets/Navigation';
import { AuthStore } from '../providers/auth';
import {
  ACCOUNT_ACTIVITY_ROUTE,
  ACCOUNT_STATEMENT_ROUTE,
  ACTIONS_ROUTE,
  BENEFICIARIES_ROUTE,
  CASE_LIST_ROUTE,
  COBRA_BENEFITS_ENROLLMENT_ROUTE,
  DASHBOARD_ROUTE,
  DB_INACTIVE_DASHBOARD_ROUTE,
  DC_INACTIVE_DASHBOARD_ROUTE,
  DIRECT_DEPOSIT_ROUTE,
  DOCUMENT_SEARCH_ROUTE,
  HEALTH_INSURANCE_ROUTH,
  HEALTH_SUMMARY,
  HSA_INVESTMENT_ROUTE,
  HSSC_ROUTE,
  HW_DB_INACTIVE_DASHBOARD_ROUTE,
  INACTIVE_RETIREMENT_ELIGIBLE_DASHBOARD_ROUTE,
  LIFE_EVENTS_ROUTE,
  OPTIMIZER_ROUTE,
  OPTIMIZER_SCORE_ROUTE,
  PARTICIPANT_ACCESS_ROUTE,
  PAYMENT_INFO_ROUTE,
  PAY_NOW_ROUTE,
  PENSION_INDEX_ROUTE,
  PENSION_PROFILE_ROUTE,
  PENSION_ROUTE,
  PROFILE_ROUTE,
  RESOURCES_ROUTE,
  RETIREMENT_PLANNING_ROUTE,
  RETIRE_ROUTE,
  SAVINGS_ROUTE,
  SAVINGS_SUMMARY,
  TAX_WITHHOLDING_ROUTE,
  MISSED_BENEFIT_PAYMENTS_ROUTE,
  DOCUMENT_CENTER_ROUTE,
  TOTAL_REWARDS_ROUTE,
  TRANSACTION_HISTORY_ROUTE,
  VERIFY_DEPENDENT_ROUTE,
  HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE,
} from './types';
import HealthSavingsAndSpendingChannelInactive from '../pages/widgets/dashboards/HealthSavingsAndSpendingsInactive';

function PrivateRoutes() {
  const [, , , selectedPersona] = useContext(AuthStore) || [];

  const defaultRoute = useMemo(() => {
    if (selectedPersona === 'persona-db') {
      return <PensionIndex />;
    }

    if (selectedPersona === 'persona-db-inactive') {
      return <DbInactiveDashboard />;
    }

    if (selectedPersona === 'persona-db-unpaid-leave') {
      return <DbUnpaidLeaveDashboard />;
    }

    if (selectedPersona === 'persona-hw') {
      return <HwDashboard />;
    }

    if (selectedPersona === 'persona-hw-db') {
      return <HwDbDashboard />;
    }

    if (selectedPersona === 'persona-hw-db-inactive') {
      return <HwDbDashboardInactive />;
    }

    if (selectedPersona === 'persona-dc') {
      return <DcDashboard />;
    }

    if (selectedPersona === 'persona-dc-unpaid-leave') {
      return <DcUnpaidLeaveDashboard />;
    }

    if (selectedPersona === 'persona-hw-dc') {
      return <HwDcDashboard />;
    }

    if (selectedPersona === 'persona-hw-db-dc') {
      return <ActiveRetirementEligibleDashboard />;
    }

    if (selectedPersona === 'persona-hw-db-dc-midyear') {
      return <HwDbDcMidYearDashboard />;
    }

    if (selectedPersona === 'persona-hw-db-dc-unpaid-leave') {
      return <ActiveRetirementEligibleUnpaidDashboard />;
    }

    if (selectedPersona === 'persona-hw-db-dc-inactive') {
      return <InactiveRetirementEligibleDashboard />;
    }

    if (selectedPersona === 'persona-hw-dc-newhire') {
      return <NewHireDashboard />;
    }

    if (selectedPersona === 'persona-dc-inactive') {
      return <DcInactiveDashboard />;
    }

    if (selectedPersona === 'persona-hw-inactive') {
      return <HwInactiveDashboard />;
    }

    if (selectedPersona === 'persona-hw-cobra') {
      return <HwCobraDashboard />;
    }

    if (selectedPersona === 'persona-hw-unpaid-leave') {
      return <HwUnpaidLeaveDashboard />;
    }

    if (selectedPersona === 'persona-hw-db-dc-cobra') {
      return <HwDbDcCobraDashboard />;
    }

    return <DashboardPage />;
  }, [selectedPersona]);

  return (
    <DashboardWrap>
      <Navigation />
      <Routes>
        <Route path="/" element={defaultRoute}></Route>
        <Route path={DASHBOARD_ROUTE} element={defaultRoute}></Route>
        <Route
          path={CASE_LIST_ROUTE}
          element={<CaseList />}
        ></Route>
        <Route
          path={PARTICIPANT_ACCESS_ROUTE}
          element={<ParticipantAccess />}
        ></Route>
        <Route
          path={DOCUMENT_SEARCH_ROUTE}
          element={<DocumentSearch />}
        ></Route>

        <Route path={SAVINGS_SUMMARY} element={<SavingsSummary />}></Route>
        <Route
          path={HEALTH_INSURANCE_ROUTH}
          element={<HealthAndInsurancePage />}
        ></Route>
        <Route
          path={HSSC_ROUTE}
          element={<HealthSavingsAndSpendingChannelPage />}
        ></Route>
        <Route path={PROFILE_ROUTE} element={<ProfilePage />}>
          <Route path={BENEFICIARIES_ROUTE} element={<Beneficiaries />}></Route>
          <Route
            path={HSA_INVESTMENT_ROUTE}
            element={<HsaInvestment />}
          ></Route>
        </Route>
        <Route
          path={VERIFY_DEPENDENT_ROUTE}
          element={<VerifyDependetPage />}
        ></Route>
        <Route path={RESOURCES_ROUTE} element={<ResourcesPage />}></Route>
        <Route path={RETIRE_ROUTE} element={<RetireOnline />}></Route>
        <Route path={SAVINGS_ROUTE} element={<SavingsEnrollment />}></Route>
        <Route
          path={TRANSACTION_HISTORY_ROUTE}
          element={<TransactionHistory />}
        ></Route>
        <Route path={LIFE_EVENTS_ROUTE} element={<LifeEvents />}></Route>
        <Route path={TOTAL_REWARDS_ROUTE} element={<TotalRewards />}></Route>
        <Route
          path={ACCOUNT_ACTIVITY_ROUTE}
          element={<AccountActivity />}
        ></Route>
        <Route
          path={MISSED_BENEFIT_PAYMENTS_ROUTE}
          element={<MissedBenefitPayments />}
        ></Route>
         <Route
          path={DOCUMENT_CENTER_ROUTE}
          element={<DocumentCenter />}
        ></Route>
        <Route
          path={RETIREMENT_PLANNING_ROUTE}
          element={<RetirementPlanning />}
        ></Route>
        <Route path={ACTIONS_ROUTE} element={<Actions />}></Route>
        <Route path={PENSION_INDEX_ROUTE} element={<PensionIndex />}></Route>
        <Route path={PENSION_ROUTE} element={<PensionEstimate />}></Route>
        <Route
          path={TAX_WITHHOLDING_ROUTE}
          element={<TaxWithholding />}
        ></Route>
        <Route
          path={PENSION_PROFILE_ROUTE}
          element={<PensionProfile />}
        ></Route>
        <Route path={DIRECT_DEPOSIT_ROUTE} element={<DirectDeposit />}></Route>
        <Route
          path={PAYMENT_INFO_ROUTE}
          element={<PaymentInformation />}
        ></Route>
        <Route path={HEALTH_SUMMARY} element={<PaymentInformation />}></Route>
        <Route path={PAY_NOW_ROUTE} element={<PayNow />}></Route>
        <Route
          path={ACCOUNT_STATEMENT_ROUTE}
          element={<AccountStatement />}
        ></Route>
        <Route
          path={DB_INACTIVE_DASHBOARD_ROUTE}
          element={<DbInactiveDashboard />}
        ></Route>
        <Route
          path={DC_INACTIVE_DASHBOARD_ROUTE}
          element={<DcInactiveDashboard />}
        ></Route>
        <Route
          path={HW_DB_INACTIVE_DASHBOARD_ROUTE}
          element={<HwDbDashboardInactive />}
        ></Route>
        <Route
          path={INACTIVE_RETIREMENT_ELIGIBLE_DASHBOARD_ROUTE}
          element={<InactiveRetirementEligibleDashboard />}
        ></Route>

        <Route path={OPTIMIZER_ROUTE} element={<Optimizer />}></Route>
        <Route
          path={OPTIMIZER_SCORE_ROUTE}
          element={<OptimizerScore />}
        ></Route>
        <Route
          path={COBRA_BENEFITS_ENROLLMENT_ROUTE}
          element={<CobraBenefitsEnrollment />}
        ></Route>
        <Route
          path={HEALTH_SAVINGS_AND_SPENDINGS_INACTIVE}
          element={<HealthSavingsAndSpendingChannelInactive />}
        ></Route>
      </Routes>
      <Footer />
    </DashboardWrap>
  );
}

export default PrivateRoutes;
